export const easings = [
    {label: 'Linear', value : 'linear'},
    {label: 'EaseIn', value : 'easeOutSine'},
    {label: 'Fast', value : 'easeOutExpo'},
    {label: 'Elastic', value : 'easeInOutElastic'},
    {label: 'Bounce', value : 'easeOutBounce'},
];

